import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { deviceGuard } from './guards/device.guard';
import { publicSalesGuard } from './guards/public-sales.guard';
import { LoginComponent } from './pages/login/login.component';
import { PinEntryComponent } from './pages/pin-entry/pin-entry.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'set-password',
    loadComponent: () =>
      import('./pages/set-password/set-password.component').then((m) => m.SetPasswordComponent),
  },
  {
    path: 'enroll-device',
    loadComponent: () =>
      import('./pages/enroll-device/enroll-device.component').then((m) => m.EnrollDeviceComponent),
  },
  { path: 'pin-entry', component: PinEntryComponent, canActivate: [deviceGuard] },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'dashboard/company',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/company-dashboard/company-dashboard.component').then(
        (m) => m.CompanyDashboardComponent
      ),
  },
  {
    path: 'recipes',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/recipes/recipes.component').then((m) => m.RecipesComponent),
  },
  {
    path: 'recipes/add',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/recipes/add-recipe/add-recipe.component').then((m) => m.AddRecipeComponent),
  },
  {
    path: 'recipes/edit/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/recipes/add-recipe/add-recipe.component').then((m) => m.AddRecipeComponent),
  },
  {
    path: 'recipes/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/recipes/recipe-detail/recipe-detail.component').then(
        (m) => m.RecipeDetailComponent
      ),
  },
  {
    path: 'ingredients',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/ingredients/ingredients.component').then((m) => m.IngredientsComponent),
  },
  {
    path: 'ingredients/add',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/ingredients/add-ingredient/add-ingredient.component').then(
        (m) => m.AddIngredientComponent
      ),
  },
  {
    path: 'stationSetup',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/station-setup/station-setup.component').then((m) => m.StationSetupComponent),
  },
  {
    path: 'products/add',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/products/add-product/add-product.component').then(
        (m) => m.AddProductComponent
      ),
  },
  {
    path: 'products/edit/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/products/add-product/add-product.component').then(
        (m) => m.AddProductComponent
      ),
  },
  {
    path: 'option-groups',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/option-groups/option-groups.component').then((m) => m.OptionGroupsComponent),
  },
  {
    path: 'products',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/products/products.component').then((m) => m.ProductsComponent),
  },
  {
    path: 'menu',
    canActivate: [authGuard, publicSalesGuard],
    loadComponent: () => import('./pages/menu/menu.component').then((m) => m.MenuComponent),
  },
  {
    path: 'menu-settings',
    canActivate: [authGuard, publicSalesGuard],
    loadComponent: () =>
      import('./pages/menu-settings/menu-settings.component').then((m) => m.MenuSettingsComponent),
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/notifications/notifications.component').then((m) => m.NotificationsComponent),
  },
  {
    path: 'alert-settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/alert-settings/alert-settings.component').then(
        (m) => m.AlertSettingsComponent
      ),
  },
  {
    path: 'financial-settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/financial-settings/financial-settings.component').then(
        (m) => m.FinancialSettingsComponent
      ),
  },
  {
    path: 'printing-settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/printing-settings/printing-settings.component').then(
        (m) => m.PrintingSettingsComponent
      ),
  },
  {
    path: 'kitchen-settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/kitchen-settings/kitchen-settings.component').then(
        (m) => m.KitchenSettingsComponent
      ),
  },
  {
    path: 'e-invoicing',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/e-invoicing/e-invoicing.component').then((m) => m.EInvoicingComponent),
  },
  {
    path: 'restaurant-schedule',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/restaurant-schedule/restaurant-schedule.component').then(
        (m) => m.RestaurantScheduleComponent
      ),
  },
  {
    path: 'stock-overview',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/stock-overview/stock-overview.component').then(
        (m) => m.StockOverviewComponent
      ),
  },
  {
    path: 'stock-history',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/stock-history/stock-history.component').then((m) => m.StockHistoryComponent),
  },
  {
    path: 'internal-orders',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/internal-orders/internal-orders.component').then(
        (m) => m.InternalOrdersComponent
      ),
  },
  {
    path: 'purchasing',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/purchasing/purchasing.component').then((m) => m.PurchasingComponent),
  },
  {
    path: 'suppliers',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/suppliers/suppliers.component').then((m) => m.SuppliersComponent),
  },
  {
    path: 'cash-register',
    canActivate: [authGuard, publicSalesGuard],
    data: { wakeLock: true },
    loadComponent: () =>
      import('./pages/cash-register/cash-register.component').then((m) => m.CashRegisterComponent),
  },
  {
    path: 'closures',
    canActivate: [authGuard, publicSalesGuard],
    loadComponent: () =>
      import('./pages/closures/closures.component').then((m) => m.ClosuresComponent),
  },
  {
    path: 'corrections',
    canActivate: [authGuard, publicSalesGuard],
    loadComponent: () =>
      import('./pages/corrections/corrections.component').then((m) => m.CorrectionsComponent),
  },
  {
    path: 'fiscal-journal',
    canActivate: [authGuard, publicSalesGuard],
    loadComponent: () =>
      import('./pages/fiscal-journal/fiscal-journal.component').then(
        (m) => m.FiscalJournalComponent
      ),
  },
  {
    path: 'legal-watch',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/legal-watch/legal-watch.component').then((m) => m.LegalWatchComponent),
  },
  {
    path: 'suppliers/add',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/suppliers/add-supplier/add-supplier.component').then(
        (m) => m.AddSupplierComponent
      ),
  },
  {
    path: 'suppliers/edit/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/suppliers/add-supplier/add-supplier.component').then(
        (m) => m.AddSupplierComponent
      ),
  },
  {
    path: 'suppliers/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/suppliers/supplier-detail/supplier-detail.component').then(
        (m) => m.SupplierDetailComponent
      ),
  },
  {
    path: 'production',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/production/productions.component').then((m) => m.ProductionsComponent),
  },
  {
    path: 'production/new',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/production/new-production/new-production.component').then(
        (m) => m.NewProductionComponent
      ),
  },
  {
    path: 'production/shelf-life',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/production/shelf-life-rules/shelf-life-rules.component').then(
        (m) => m.ShelfLifeRulesComponent
      ),
  },
  {
    path: 'production/:id/label',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/production/production-label/production-label.component').then(
        (m) => m.ProductionLabelComponent
      ),
  },
  {
    path: 'production/opened/:id/label',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/production/opened-ingredient-label/opened-ingredient-label.component').then(
        (m) => m.OpenedIngredientLabelComponent
      ),
  },
  {
    path: 'staff-schedule/absences',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/staff-schedule/absences/absences.component').then((m) => m.AbsencesComponent),
  },
  {
    path: 'staff-schedule/advances',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/staff-schedule/advances/advances.component').then((m) => m.AdvancesComponent),
  },
  {
    path: 'staff-schedule/replacements',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/staff-schedule/replacements/replacements.component').then(
        (m) => m.ReplacementsComponent
      ),
  },
  {
    path: 'staff-schedule',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/staff-schedule/staff-schedule.component').then(
        (m) => m.StaffScheduleComponent
      ),
  },
  {
    path: 'my-planning',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/my-planning/my-planning.component').then((m) => m.MyPlanningComponent),
  },
  {
    path: 'user-roles',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/user-roles/user-roles.component').then((m) => m.UserRolesComponent),
  },
  {
    path: 'roles/add',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/roles/add-role/add-role.component').then((m) => m.AddRoleComponent),
  },
  {
    path: 'roles/edit/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/roles/add-role/add-role.component').then((m) => m.AddRoleComponent),
  },
  {
    path: 'roles',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/roles/roles.component').then((m) => m.RolesComponent),
  },
  {
    path: 'categories/add',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/categories/add-category/add-category.component').then(
        (m) => m.AddCategoryComponent
      ),
  },
  {
    path: 'categories/edit/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/categories/add-category/add-category.component').then(
        (m) => m.AddCategoryComponent
      ),
  },
  {
    path: 'categories',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/categories/categories.component').then((m) => m.CategoriesComponent),
  },
  {
    path: 'users/add',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/users/add-user/add-user.component').then((m) => m.AddUserComponent),
  },
  {
    path: 'users/edit/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/users/add-user/add-user.component').then((m) => m.AddUserComponent),
  },
  {
    path: 'users/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/users/user-detail/user-detail.component').then((m) => m.UserDetailComponent),
  },
  {
    path: 'users',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/users/users.component').then((m) => m.UsersComponent),
  },
  {
    path: 'map-editor',
    canActivate: [authGuard, publicSalesGuard],
    data: { wakeLock: true },
    loadComponent: () =>
      import('./pages/map-editor/map-editor.component').then((m) => m.MapEditorComponent),
  },
  {
    path: 'reservations',
    canActivate: [authGuard, publicSalesGuard],
    loadComponent: () =>
      import('./pages/reservations/reservations.component').then((m) => m.ReservationsComponent),
  },
  {
    path: 'order-preparation',
    canActivate: [authGuard, publicSalesGuard],
    data: { wakeLock: true },
    loadComponent: () =>
      import('./pages/order-preparation/order-preparation.component').then(
        (m) => m.OrderPreparationComponent
      ),
  },
  {
    path: 'orders',
    canActivate: [authGuard, publicSalesGuard],
    loadComponent: () => import('./pages/orders/orders.component').then((m) => m.OrdersComponent),
  },
  {
    path: 'orders/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/orders/order-detail/order-detail.component').then(
        (m) => m.OrderDetailComponent
      ),
  },
  {
    path: 'tasks/add-template',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/tasks/add-template/add-template.component').then(
        (m) => m.AddTaskTemplateComponent
      ),
  },
  {
    path: 'tasks/edit-template/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/tasks/add-template/add-template.component').then(
        (m) => m.AddTaskTemplateComponent
      ),
  },
  {
    path: 'tasks',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/tasks/tasks.component').then((m) => m.TasksComponent),
  },
  {
    path: 'my-tasks',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/my-tasks/my-tasks.component').then((m) => m.MyTasksComponent),
  },
  // Must stay after every static route: a restaurant slug only matches what nothing else claimed.
  {
    path: ':slug',
    data: { publicPage: true },
    loadComponent: () =>
      import('./pages/public-menu/public-menu.component').then((m) => m.PublicMenuComponent),
  },
  { path: '**', redirectTo: '' },
];
